import { useState, type ReactNode } from 'react';

/*  UNA SEZIONE DELLA SCHEDA CHE SI CHIUDE CON LA FRECCIA, come «Parametri e date».

    Chiesto da Galizzi il 16/10/2026: invece di dividere il preventivo in passi o
    etichette — discusso e scartato — «lascia cosi' e fai i parametri della tendina per
    chiuderli». Su un preventivo da trecento righe chi lavora sulle righe chiude il
    cantiere e le spese, e la pagina torna corta.

    Aperta all'ingresso, sempre: chi apre un'offerta deve vedere tutto, e una sezione
    che nasce chiusa e' una sezione che qualcuno si dimentica di guardare. Lo stato non
    si ricorda fra un'apertura e l'altra per lo stesso motivo.

    Il titolo resta un h3 dentro il summary: cosi' ha lo stesso aspetto di prima e chi
    legge con lo screen reader trova ancora le sezioni come titoli.  */
export function SezioneChiudibile({
  classe,
  titolo,
  livello = 3,
  children,
}: {
  classe: string;
  titolo: ReactNode;
  livello?: 2 | 3;
  children: ReactNode;
}) {
  const [aperta, setAperta] = useState(true);
  const Titolo = livello === 2 ? 'h2' : 'h3';

  return (
    <details
      className={`${classe} sezione-chiudibile`}
      open={aperta}
      onToggle={(e) => setAperta(e.currentTarget.open)}
    >
      <summary>
        <Titolo>{titolo}</Titolo>
      </summary>
      {children}
    </details>
  );
}
